import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";

@Component({
  selector: 'app-bookings-accepted',
  templateUrl: './bookings-accepted.component.html',
  styleUrls: ['./bookings-accepted.component.scss']
})
export class BookingsAcceptedComponent implements OnInit {
  bookings:any [];
  listOfData:any [];
  modalRef: BsModalRef;
  requestId: any;
  page: any;
  totalRec: any;
  currentPage: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
  }

  ngOnInit() {
    this.getAll(1);
  }

  createModal() {

  }

  getAll(pageIndex){
    let req={}
    let size = 10;
    let page = pageIndex - 1;
    this.userService.ticketbookinggetAll(size,page,req).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.bookings =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  save() {
    this.userService.ticketbookingSave().subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  confiremBocking(id) {
    this.userService.ticketconfiremBooking(id).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.getAll(this.currentPage);
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  cancelBooking(id) {
    this.userService.ticketcancelBooking(id).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.getAll(this.currentPage);
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  declineConfirem() {
    this.modalRef.hide();
  }

  confirmConfirem() {
    this.confiremBocking(this.requestId);
  }

  openModal(template,id) {
    this.requestId =id;
    this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered'});
  }

  declineCancel() {
    this.modalRef.hide();
  }

  confirmCancel() {
    this.cancelBooking(this.requestId)
  }
}
